<template>
    <tr 

    class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50">
        <td class="tw-px-2 tw-py-3">
            <div class="tw-flex tw-items-center tw-gap-2">
                <icon v-if="[0, 1, 2].includes(props.index) && props.page == 1" icon="fluent:trophy-24-filled" class="tw-text-lg"
                :class=" [
                    (props.index == 0 && props.page == 1) && 'tw-text-amber-300',
                    (props.index == 1 && props.page == 1) && 'tw-text-gray-300',
                    (props.index == 2 && props.page == 1) && 'tw-text-orange-400'
                    ] "
                />
                <div :title="item.name"
                    class="tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-w-[200px] tw-truncate">
                    {{ item.name }}
                </div>
            </div>
        </td>
        <td class="tw-px-2 tw-py-3">
            <div
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center">
                {{ formatNumber(item.total_orders, {}) }}
            </div>
        </td>
        <td class="tw-px-2 tw-py-3">
            <div class="tw-flex tw-flex-col tw-items-center">
                <div class="tw-font-[cairo] tw-text-sm">
                    {{ formatNumber(item.total_confirmed_orders, {}) }}
                </div>
                <div class="tw-text-xs tw-text-gray-500 tw-mt-0.5">
                    {{ formatNumber(calculateConfirmationRate(item), { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }) }}
                </div>
            </div>
        </td>
        <td title="(Delivered in range)" class="tw-px-2 tw-py-3">
            <div class="tw-flex tw-flex-col tw-items-center">
                <div class="tw-font-[cairo] tw-text-sm">
                    <span>{{ formatNumber(item.total_delivered_orders, {}) }}</span>
                </div>
                <div class="tw-text-xs tw-text-gray-500 tw-mt-0.5">
                    {{ formatNumber(calculateDeliveryRate(item), { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }) }}
                </div>
            </div>
        </td>
        <td class="tw-px-2 tw-py-3">
            <div
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center">
                {{ formatNumber(item.total_delivered_quantity, {}) }}
            </div>
        </td>
        <td class="tw-px-2 tw-py-3">
            <div
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-sky-500 tw-flex tw-items-end tw-justify-center tw-gap-1">
                <span>{{ formatNumber(item.total_turnover) }}</span>
            </div>
        </td>
        <td class="tw-px-2 tw-py-3">
            <div
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-gray-500">
                {{ formatNumber (item.total_delivered_product_cost) }}
            </div>
        </td>
        
        <td class="tw-px-2 tw-py-3">
            <div
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-purple-500 tw-flex tw-items-end tw-justify-center tw-gap-1">
                <span>{{ formatNumber(item.shipping_cost) }}</span>
            </div>
        </td>

        <td class="tw-px-2 tw-py-3">
            <div
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-amber-500">
                {{ formatNumber(item.total_spend) }}
            </div>
        </td>

        <td class="tw-px-2 tw-py-3">
            <div
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-pink-500">
                {{ formatNumber(item.total_delivered_orders * 1) }}
            </div>
        </td>

        <td class="tw-px-2 tw-py-3">
            <div
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-gray-500">
                {{ formatNumber(calculateCostPerOrder(item)) }}
            </div>
        </td>


        <td class="tw-px-2 tw-py-3">
            <div
                :class="[(item.profit_per_order) <= 0 && '!tw-text-rose-500 tw-bg-rose-100']"
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-emerald-500">
                {{ formatNumber(item.profit_per_order) }}
            </div>
        </td>

        <td class="tw-px-2 tw-py-3">
            <div
                :class="[item.profit_per_unit <= 0 && '!tw-text-rose-500 tw-bg-rose-100']"
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-emerald-500">
                {{ formatNumber(item.profit_per_unit) }}
            </div>
        </td>

        <td class="tw-px-2 tw-py-3">
            <div
                :class="[item.total_profit <= 0 && '!tw-text-rose-500 tw-bg-rose-100']"
                class="tw-w-full tw-py-1 tw-px-1 tw-font-[cairo] tw-text-sm tw-text-center tw-font-bold tw-text-emerald-500">
                {{ formatNumber(item.total_profit) }}
            </div>
        </td>

        <td class="tw-px-2 tw-py-3">
            <div class="tw-flex tw-justify-center tw-gap-1">
                <button @click="toggleExpand" class="tw-p-1 tw-rounded hover:tw-bg-gray-100">
                    <icon 
                        :icon="expanded ? 'mdi:chevron-up' : 'mdi:chevron-down'" 
                        class="tw-text-lg tw-text-gray-500" 
                    />
                </button>
                <button @click="showMarketersPopup = true" class="tw-p-1 tw-rounded hover:tw-bg-gray-100" title="View Marketers">
                    <icon icon="mdi:account-group" class="tw-text-lg tw-text-gray-500" />
                </button>
                <button @click="showAgentsPopup = true" class="tw-p-1 tw-rounded hover:tw-bg-gray-100" title="View Agents">
                    <icon icon="mdi:account-tie" class="tw-text-lg tw-text-gray-500" />
                </button>
            </div>
        </td>
    </tr>
    <tr v-if="expanded" class="tw-border-b tw-border-solid tw-border-gray-100">
        <td :colspan="15" class="tw-px-0 tw-py-0">
            <div class="tw-bg-gray-50 tw-px-4 tw-py-3">
                <div v-if="detailsLoading" class="tw-flex tw-justify-center tw-items-center tw-py-6">
                    <icon icon="eos-icons:three-dots-loading" class="tw-text-3xl tw-text-gray-400" />
                    <p class="tw-ml-2 tw-text-gray-500">{{ $t('common.loading-data') }}</p>
                </div>
                <div v-else-if="detailsError" class="tw-text-center tw-py-4 tw-text-rose-500">
                    {{ $t('common.failed-to-load') }}
                </div>
                <div v-else-if="detailsData" class="tw-py-1">
                    <div class="tw-flex tw-justify-between tw-mb-2">
                        <h4 class="tw-font-bold tw-text-sm tw-text-gray-700">{{ $t('common.previous-period') }}</h4>
                        <div class="tw-text-xs tw-text-gray-500">
                            {{ formatDateRange(previousPeriodDates.from, previousPeriodDates.to) }}
                        </div>
                    </div>
                    
                    <div class="tw-grid tw-grid-cols-4 tw-gap-2 tw-mb-2">
                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('common.orders') }}</p>
                            <p class="tw-font-bold tw-text-sm">{{ formatNumber(detailsData.total_orders, {}) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_orders, item.total_orders)">
                                <icon :icon="getComparisonIcon(detailsData.total_orders, item.total_orders)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_orders, item.total_orders) }}</span>
                            </div>
                        </div>
                        
                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('common.confirmed') }}</p>
                            <p class="tw-font-bold tw-text-sm">{{ formatNumber(detailsData.total_confirmed_orders, {}) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_confirmed_orders, item.total_confirmed_orders)">
                                <icon :icon="getComparisonIcon(detailsData.total_confirmed_orders, item.total_confirmed_orders)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_confirmed_orders, item.total_confirmed_orders) }}</span>
                            </div>
                        </div>
                        
                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('common.delivered') }}</p>
                            <p class="tw-font-bold tw-text-sm">{{ formatNumber(detailsData.total_delivered_orders, {}) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_delivered_orders, item.total_delivered_orders)">
                                <icon :icon="getComparisonIcon(detailsData.total_delivered_orders, item.total_delivered_orders)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_delivered_orders, item.total_delivered_orders) }}</span>
                            </div>
                        </div>

                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('common.duplicates') }}</p>
                            <p class="tw-font-bold tw-text-sm">{{ formatNumber(detailsData.total_duplicated_orders, {}) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_duplicated_orders, item.total_duplicated_orders)">
                                <icon :icon="getComparisonIcon(detailsData.total_duplicated_orders, item.total_duplicated_orders)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_duplicated_orders, item.total_duplicated_orders) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="tw-grid tw-grid-cols-4 tw-gap-2 tw-mb-2">
                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('common.delivered-range') }}</p>
                            <p class="tw-font-bold tw-text-sm">{{ formatNumber(detailsData.total_delivered_orders_in_range, {}) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_delivered_orders_in_range, item.total_delivered_orders_in_range)">
                                <icon :icon="getComparisonIcon(detailsData.total_delivered_orders_in_range, item.total_delivered_orders_in_range)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_delivered_orders_in_range, item.total_delivered_orders_in_range) }}</span>
                            </div>
                        </div>
                        
                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('fields.quantity') }}</p>
                            <p class="tw-font-bold tw-text-sm">{{ formatNumber(detailsData.total_delivered_quantity, {}) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_delivered_quantity, item.total_delivered_quantity)">
                                <icon :icon="getComparisonIcon(detailsData.total_delivered_quantity, item.total_delivered_quantity)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_delivered_quantity, item.total_delivered_quantity) }}</span>
                            </div>
                        </div>
                        
                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('pages.dashboard.kpis.total-turnover') }}</p>
                            <p class="tw-font-bold tw-text-sm tw-text-sky-500">{{ formatNumber(detailsData.total_turnover) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_turnover, item.total_turnover)">
                                <icon :icon="getComparisonIcon(detailsData.total_turnover, item.total_turnover)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_turnover, item.total_turnover) }}</span>
                            </div>
                        </div>
                        
                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('pages.dashboard.kpis.product-cost') }}</p>
                            <p class="tw-font-bold tw-text-sm tw-text-gray-500">{{ formatNumber(detailsData.total_delivered_product_cost) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_delivered_product_cost, item.total_delivered_product_cost)">
                                <icon :icon="getComparisonIcon(detailsData.total_delivered_product_cost, item.total_delivered_product_cost)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_delivered_product_cost, item.total_delivered_product_cost) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="tw-grid tw-grid-cols-4 tw-gap-2">
                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('pages.dashboard.kpis.shipping-cost') }}</p>
                            <p class="tw-font-bold tw-text-sm tw-text-purple-500">{{ formatNumber(detailsData.shipping_cost) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.shipping_cost, item.shipping_cost)">
                                <icon :icon="getComparisonIcon(detailsData.shipping_cost, item.shipping_cost)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.shipping_cost, item.shipping_cost) }}</span>
                            </div>
                        </div>

                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('pages.dashboard.kpis.ads') }}</p>
                            <p class="tw-font-bold tw-text-sm tw-text-amber-500">{{ formatNumber(detailsData.total_spend) }}</p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_spend, item.total_spend)">
                                <icon :icon="getComparisonIcon(detailsData.total_spend, item.total_spend)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_spend, item.total_spend) }}</span>
                            </div>
                        </div>

                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('pages.dashboard.kpis.profit-per-order') }}</p>
                            <p class="tw-font-bold tw-text-sm" :class="detailsData.profit_per_order <= 0 ? 'tw-text-rose-500' : 'tw-text-emerald-500'">
                                {{ formatNumber(detailsData.profit_per_order) }}
                            </p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.profit_per_order, item.profit_per_order)">
                                <icon :icon="getComparisonIcon(detailsData.profit_per_order, item.profit_per_order)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.profit_per_order, item.profit_per_order) }}</span>
                            </div>
                        </div>

                        <div class="tw-bg-white tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                            <p class="tw-text-xs tw-text-gray-500">{{ $t('pages.dashboard.kpis.net-profit') }}</p>
                            <p class="tw-font-bold tw-text-sm" :class="detailsData.total_profit <= 0 ? 'tw-text-rose-500' : 'tw-text-emerald-500'">
                                {{ formatNumber(detailsData.total_profit) }}
                            </p>
                            <div class="tw-flex tw-items-center" :class="getComparisonClass(detailsData.total_profit, item.total_profit)">
                                <icon :icon="getComparisonIcon(detailsData.total_profit, item.total_profit)" class="tw-text-xs" />
                                <span class="tw-text-xs tw-ml-1">{{ formatComparison(detailsData.total_profit, item.total_profit) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </td>
    </tr>

    <!-- Popups -->
    <ProductMarketersPopup
        v-model="showMarketersPopup"
        :product-id="item.id"
        :filters="filters"
    />
    <ProductAgentsPopup
        v-model="showAgentsPopup"
        :product-id="item.id"
        :filters="filters"
    />
</template>

<script setup>
import { defineProps, toRef, inject, ref, watch } from 'vue';
import { productDetails } from '@/api/analytics';
import ProductMarketersPopup from '@/components/dashboard/admin/products/popups/ProductMarketersPopup.vue';
import ProductAgentsPopup from '@/components/dashboard/admin/products/popups/ProductAgentsPopup.vue';

const props = defineProps(['item', 'index', 'page', 'filters'])
const item = toRef(props, 'item');
const exchange = inject('exchange', ref(4.88));
const filters = toRef(props, 'filters');

const expanded = ref(false);
const detailsLoading = ref(false);
const detailsData = ref(null);
const detailsError = ref(null);
const previousPeriodDates = ref({ from: null, to: null });

const showMarketersPopup = ref(false);
const showAgentsPopup = ref(false);

const formatNumber = (number, type = {style: 'currency', currency: 'PKR'}) => {
    return new Intl.NumberFormat('en', { maximumFractionDigits: 2, ...type }).format(number);
}


const toggleExpand = async () => {
    expanded.value = !expanded.value;
    
    if (expanded.value && !detailsData.value) {
        await fetchPreviousPeriodData();
    }
}

const calculatePreviousPeriod = () => {
    console.log('Raw filters: ', filters.value);
    
    // Check if filters has direct from/to properties (not nested under created_at)
    if (filters.value && filters.value.from && filters.value.to) {
        const currentFrom = new Date(filters.value.from);
        const currentTo = new Date(filters.value.to);
        
        console.log('Current date range:', { 
            from: currentFrom.toISOString().split('T')[0], 
            to: currentTo.toISOString().split('T')[0] 
        });
        
        // Calculate the difference in days between the current date range
        const diffTime = Math.abs(currentTo - currentFrom);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end dates
        
        console.log('Date difference calculations:', { diffTime, diffDays });
        
        // Always use the same length range but immediately before the current period
        const previousTo = new Date(currentFrom);
        previousTo.setDate(previousTo.getDate() - 1); // The day before the current from date
        
        const previousFrom = new Date(previousTo);
        previousFrom.setDate(previousFrom.getDate() - (diffDays - 1)); // Go back by the same number of days as the current range
        
        console.log('Previous period calculated:', { 
            previousFrom: previousFrom.toISOString().split('T')[0],
            previousTo: previousTo.toISOString().split('T')[0],
            diffDays
        });
        
        return {
            from: previousFrom.toISOString().split('T')[0],
            to: previousTo.toISOString().split('T')[0]
        };
    }
    
    // Default to last month if no date range
    const today = new Date();
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
    const lastMonthStart = new Date(lastMonthEnd.getFullYear(), lastMonthEnd.getMonth(), 1);
    
    console.log('Using default last month:', {
        from: lastMonthStart.toISOString().split('T')[0],
        to: lastMonthEnd.toISOString().split('T')[0]
    });
    
    return {
        from: lastMonthStart.toISOString().split('T')[0],
        to: lastMonthEnd.toISOString().split('T')[0]
    };
}

const fetchPreviousPeriodData = async () => {
    detailsLoading.value = true;
    detailsError.value = null;
    
    try {
        const dateRange = calculatePreviousPeriod();
        previousPeriodDates.value = dateRange;
        
        console.log('Fetching previous period data with date range:', dateRange);
        
        // Create a new parameters object from filters excluding from/to dates
        const params = { ...filters.value };
        
        // Remove the original from/to dates to avoid conflict
        delete params.from;
        delete params.to;
        delete params.created_at; // Just in case
        
        // Add the calculated date range and exchange rate
        params.from = dateRange.from;
        params.to = dateRange.to;
        params.exchange = exchange.value;
        
        console.log('API parameters:', params);
        
        const response = await productDetails(item.value.id, params);
        console.log('API Response:', response);

        // More flexible response handling
        if (response && response.data) {
            if (response.data.code === 'SUCCESS' || response.status === 200) {
                // Check where the data is located in the response
                if (response.data.data) {
                    detailsData.value = response.data.data;
                } else {
                    // If data is directly in the response.data object
                    detailsData.value = response.data;
                }
                console.log('Details data loaded:', detailsData.value);
            } else {
                detailsError.value = response.data.message || 'Failed to load product details.';
                console.error('API error:', detailsError.value);
            }
        } else {
            detailsError.value = 'Invalid response from server.';
            console.error('Invalid API response');
        }
    } catch (error) {
        console.error('Error fetching product details:', error);
        detailsError.value = 'An error occurred while loading product details.';
    } finally {
        detailsLoading.value = false;
    }
}

const formatDateRange = (from, to) => {
    if (!from || !to) return '';
    
    const fromDate = new Date(from);
    const toDate = new Date(to);
    
    return `${fromDate.toLocaleDateString()} - ${toDate.toLocaleDateString()}`;
}

const formatComparison = (prevValue, currentValue) => {
    if (prevValue === 0 && currentValue === 0) return '0%';
    if (prevValue === 0 && currentValue > 0) return '+100%';
    if (prevValue > 0 && currentValue === 0) return '-100%';
    if (!prevValue || !currentValue) return '0%';
    
    const diff = ((currentValue - prevValue) / prevValue) * 100;
    return `${diff > 0 ? '+' : ''}${Math.abs(diff).toFixed(1)}%`;
}

const getComparisonClass = (prevValue, currentValue) => {
    if (prevValue === 0 && currentValue === 0) return 'tw-text-gray-500';
    if (prevValue === 0 && currentValue > 0) return 'tw-text-emerald-500';
    if (prevValue > 0 && currentValue === 0) return 'tw-text-rose-500';
    if (!prevValue || !currentValue) return 'tw-text-gray-500';
    
    const diff = currentValue - prevValue;
    return diff > 0 ? 'tw-text-emerald-500' : diff < 0 ? 'tw-text-rose-500' : 'tw-text-gray-500';
}

const getComparisonIcon = (prevValue, currentValue) => {
    if (prevValue === 0 && currentValue === 0) return 'mdi:minus';
    if (prevValue === 0 && currentValue > 0) return 'mdi:arrow-up';
    if (prevValue > 0 && currentValue === 0) return 'mdi:arrow-down';
    if (!prevValue || !currentValue) return 'mdi:minus';
    
    const diff = currentValue - prevValue;
    return diff > 0 ? 'mdi:arrow-up' : diff < 0 ? 'mdi:arrow-down' : 'mdi:minus';
}

const calculateCostPerOrder = (item) => {
    if (!item.total_orders || item.total_orders === 0) return 0;
    const totalCost = item.total_spend;
    return totalCost / item.total_orders;
}

const calculateConfirmationRate = (item) => {
    if (!item.total_orders) return 0;
    return item.total_confirmed_orders / (item.total_orders - item.total_duplicated_orders);
}

const calculateDeliveryRate = (item) => {
    if (!item.total_confirmed_orders) return 0;
    return item.total_delivered_orders / (item.total_confirmed_orders);
}

// Reset expanded state when filters change
watch(() => filters.value, (newVal, oldVal) => {
    console.log('Filters changed:', { newVal, oldVal });
    if (expanded.value) {
        console.log('Resetting expanded state due to filter change');
        expanded.value = false;
        detailsData.value = null;
    }
}, { deep: true });
</script>

<style></style>